module.exports = __webpack_public_path__ + "img/h5-five.17147f8f.png";